// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"513":"ffccdf77","538":"3ec29553","703":"c1d4181e","983":"b5cf90bf"}[chunkId] + ".chunk.js";
};